import { combineReducers } from 'redux';
import { createWrapperInitializer } from './next-wrapper/index.js';
import { createStore } from './create-store.js';

const HYDRATE = '@eggs/hydrate';
const defaultMiddlewareOptions = {};
function setReduxDefaultMiddlewareOptions(options = {}) {
  Object.assign(defaultMiddlewareOptions, options);
}
function getReduxDefaultMiddlewareOptions() {
  return defaultMiddlewareOptions;
}
const combiner = reducersMap => {
  const combinedReducer = combineReducers(reducersMap);
  return (state = {}, action) => {
    if (action.type === HYDRATE && action.payload) {
      return combinedReducer({
        ...state,
        ...action.payload
      }, action);
    }
    return combinedReducer(state, action);
  };
};
const createAppStore = () => createStore({
  combiner,
  defaultMiddlewareOptions
});
const wrapperInitializer = createWrapperInitializer(createAppStore, {
  hydrationActionType: HYDRATE
});
const getDuckEgg = duck => ({
  id: duck.store,
  keep: true,
  reducersMap: {
    [duck.store]: duck.reducer
  }
});

export { getDuckEgg, getReduxDefaultMiddlewareOptions, setReduxDefaultMiddlewareOptions, wrapperInitializer };
